<template>
  <div class="confirmacion-container">
    <div class="tabla-container">
     
      <p v-if="error">{{ error }}</p>
      <template v-else-if="reservacion">
          <h4>Datos de la Reservacion</h4>
          <!-- Datos del cliente -->
        <div class="headerCliente"> 
  
   <div class="client-info">
    <div class="datos-cliente">
        <p><strong>Nombre del Cliente:</strong> {{ reservacion.NombreCliente }}</p>
        <p><strong>Correo Electrónico:</strong> {{ reservacion.CorreoCliente }}</p>
        <p><strong>Número de Teléfono:</strong> {{ reservacion.NumeroCliente }}</p>
      </div>
    </div>


    <div>
  <p>
    ¡Realiza tu Pago! <br >
    <small>de las siguientes maneras:</small>
  </p>
  <ul class="payment-info">
    <li><strong>Beneficiario:</strong> Luis Raul Gracia Perez</li>
    <li><strong>Número de Tarjeta:</strong> 4169 5434 7890 1567</li>
    <li><strong>Cuenta Interbancaria:</strong> 4542 7895 4326 7854 12</li>
    <li><strong>Nombre del Banco:</strong> Bancomer</li>
    <li><strong>PayPal:</strong> pagos@chiapasincentives.com</li>
  </ul>
</div>

  </div>
        <!-- Tabla de datos de la reservación -->
        <table class="table">
          <thead>
       </thead>
          <tbody>
            <tr>
              <td><strong>Origen</strong></td>
              <td>{{ reservacion.OrigenNombre }}</td>
            </tr>
            <tr>
              <td><strong>Destino</strong></td>
              <td>{{ reservacion.DestinoNombre }}</td>
            </tr>
            <tr>
              <td><strong>Fecha</strong></td>
              <td>{{ reservacion.FechaReservacion }}</td>
            </tr>
            <tr>
              <td><strong>Hora</strong></td>
              <td>{{ reservacion.HoraReservacion }}</td>
            </tr>
            <tr>
              <td><strong>Total de Pasajeros</strong></td>
              <td>{{ reservacion.TotalPasajeros }}</td>
            </tr>
            <tr>
            <td><strong>Total a Pagar</strong></td>
            <td>{{ reservacion.CostoTotal }}</td>
          </tr>              
          </tbody>
        </table>
        <div class="text-center mt-4">
    <!-- Botón para descargar comprobante directamente -->
    <button 
      type="button"  class="boton boton-success" @click="generarPDF" >
      Obtener Comprobante
    </button>

   
  <!-- Botón para cancelar y regresar al inicio -->
<button 
  class="boton boton-danger" 
  @click="irAlInicio"
>
  Cerrar
</button>
  </div>
      
      </template>
      <p v-else>Cargando...</p>
    </div>
    
  </div>
</template>

<script>
import jsPDF from "jspdf";

export default {
  data() {
    return {
      clientes: null,
      reservacion: null, 
      error: null,
    };
  },
  mounted() {
    this.obtenerReservacion();
    this.cargarDatosCliente();
  },
  methods: {
    
    async cargarDatosCliente() {
  try {
    // Llamada a la API para obtener los datos del cliente
    const respuesta = await fetch(
      this.$backendUrl+"obtenerReservacion.php"
    );

    if (!respuesta.ok) {
      throw new Error("Error al obtener los datos del cliente.");
    }

    const datos = await respuesta.json();

    // Verifica los datos recibidos
    console.log("Datos del cliente recibidos:", datos);

    // Asigna los datos al objeto `cliente`
    this.clientes = {
      NombreCliente: datos.NombreCliente,
      CorreoCliente: datos.CorreoCliente,
      NumeroCliente: datos.NumeroCliente,
    };
  } catch (error) {
    console.error("Error al cargar los datos del cliente:", error);
  }
},


    async obtenerReservacion() {
    const folio = this.$route.query.folio; // Obtener el folio desde la URL
    console.log("Folio recibido en frontend:", folio);

    if (!folio) {
        this.error = "Folio no proporcionado.";
        return;
    }

    try {
        const response = await fetch(
            this.$backendUrl+`obtenerReservacion.php?folio=${folio}`
        );
        const data = await response.json();

        console.log("Respuesta del backend:", data);

        if (data.success) {
            this.reservacion = {
                ...data.reservacion,
                Origen: data.reservacion.OrigenNombre,
                Destino: data.reservacion.DestinoNombre,
                TotalPagar: data.reservacion.CostoTotal, // Asigna el Total a Pagar
            };
        } else {
            this.error = data.message || "Error al cargar la reservación.";
        }
    } catch (error) {
        console.error("Error al conectar con el servidor:", error);
        this.error = "Error al conectar con el servidor.";
    }
},
//NUEVO
async mounted() {
  try {
    const response = await fetch(this.$backendUrl + `confirmacion?folio=${this.folio}`);
    const data = await response.json();
    if (!data.success) {
      alert(data.message || "Acceso no autorizado.");
      this.$router.push("/error"); // Redirigir a una página de error
    } else {
      this.reservacion = data.reservacion;
    }
  } catch (error) {
    alert("Error al conectar con el servidor.");
  }
},


generarPDF() {
    if (!this.reservacion) {
        alert("No se encontraron datos para generar el comprobante.");
        return;
    }

    const doc = new jsPDF();

    // Título del documento
    doc.setFontSize(16);
    doc.text("Comprobante de Reservación", 70, 10);

    // Agregar el folio en la esquina superior derecha
    if (this.reservacion.Folio) {
      doc.setTextColor(255, 0, 0); 
    doc.setFont("helvetica", "bold"); 
    doc.setFontSize(14); 
    doc.text(`Folio: ${this.reservacion.Folio}`, 130, 20); 
    doc.setTextColor(0, 0, 0);
    }

    // Datos personales
    doc.setFontSize(12);
    doc.text(`Nombre del Cliente: ${this.reservacion.NombreCliente}`, 10, 40);
    doc.text(`Correo Electrónico: ${this.reservacion.CorreoCliente}`, 10, 50);
    doc.text(`Número de Teléfono: ${this.reservacion.NumeroCliente}`, 10, 60);

    // Datos de la reservación
    doc.text("Datos de Reservación", 80, 80);
    doc.text(`Origen: ${this.reservacion.Origen}`, 10, 90);
    doc.text(`Destino: ${this.reservacion.Destino}`, 10, 100);
    doc.text(`Fecha: ${this.reservacion.FechaReservacion}`, 10, 110);
    doc.text(`Hora: ${this.reservacion.HoraReservacion}`, 10, 120);
    doc.text(`Total de Pasajeros: ${this.reservacion.TotalPasajeros}`, 10, 130);
    doc.text(`Total a Pagar: ${this.reservacion.TotalPagar}`, 10, 140);

    // Mensaje al final de la hoja
doc.setTextColor(255, 0, 0); 
doc.setFontSize(11);
doc.setFont("helvetica", "bold");
doc.text(
    "Se le enviará un correo de confirmación para realizar el pago.",
    10,
    160
);
doc.text(
    "Tiene 24 horas para realizarlo, de lo contrario, su reservación será cancelada.",
    10,
    170
);

// Texto adicional
doc.setTextColor(0, 35, 102); 
doc.setFontSize(10); 
doc.setFont("helvetica", "normal"); 
doc.text(
    "                     ¡Realiza tu Pago!",
    60,
    190
);
doc.text(
"~Nombre del Beneficiario: Luis Raul Gracia Perez", 
    10,
    200
);
doc.text(
"~Numero de Trajeta: 4169 5434 7890 1567", 
    10,
    205
);

doc.text(
"~ Cuenta Interbancaria: 4542 7895 4326 7854 12 ", 
    10,
    210
);
doc.text(  
    "~Nombre del blanco: Bancomer", 
    10,
    215
);
    
doc.text(  
    "~Paypal: pagos@chiapasincentives.com ", 
    10,
    220
);
    
    // Descargar el PDF
    doc.save("Comprobante_Reservacion.pdf");
    setTimeout(() => {
   

    // Redirige a la página final
    this.$router.push("/Final");
}, 500);
},

irAlInicio() {
      this.$router.push("/Final"); 
    }


  },
};
</script>


  <style>
  .confirmacion-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 20px;
    background-image: url('/src/assets/fondo2.jpg');
    background-size: cover;
    background-position: center;
  }
  
  .tabla-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 110%; 
    max-width: 700px; 
    margin: 0 auto; 
  }
  
  .extra-info {
  font-family: Arial, sans-serif;
  font-size: 0.9rem; /* Reduce el tamaño del texto */
  color: #333; /* Color gris oscuro */
  margin: 10px 0;
  line-height: 1.0; /* Espaciado entre líneas */
}

.highlight-text {
  font-size: 13pz;
  font-weight: bold;
  margin-bottom: 5px;
}

.payment-info {
  list-style-type: none; /* Quitar viñetas */
  padding: 0;
  font-size: 0.7rem; /* Más pequeño para detalles */
}

.payment-info li {
  margin: 5px 0; /* Espaciado entre elementos */
}


  .headerCliente {
  display: flex;
  justify-content: space-between; 
  align-items: flex-start; 
  margin-bottom: 20px;
  margin-top: 10px; 
}
.client-info {
  width: 60%; 
  margin-top: 25px; 


}

.extra-info {
  width: 50%;
  background-color: #e4493e76;
  border: 1px solid #f60c0c;
  border-radius: 5px;
  font-size: 14px; 
  padding: 10px;
  text-align: center;
  margin-left: 20px;
}
  .table-header {
  text-align: center !important; 
  vertical-align: middle; 
  background-color: #f2f2f2; 
  font-weight: bold; 
  padding: 10px; 
}
  
  h4 {
    text-align: center;
    margin-bottom: 10px;
    font-size: 1rem; 
    color: blue !important;
  }
  
  .datos-cliente {
  margin-bottom: 8px; 
  font-size: 1rem; 
  line-height: 1.2; 
}

  .table {
    width: 100%; 
    border-collapse: collapse;
    font-size: 0.9rem; 
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  .table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }
  
  .boton {
  width: 30%; 
  margin: 5px auto; 
  margin-right: 5%; 
  padding: 5px 10px;
}

.boton-success {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
}

.boton-danger {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
}

  .text-center {
    text-align: center;
  }
  
  .mt-4 {
    margin-top: 20px;
  }
  </style>
  